"use client";
import React, { useContext, useEffect, useRef, useState } from "react";
import Scrollbars from "react-custom-scrollbars";
import $ from "jquery";
 
import Icons from "../Icons/index";

import { Context } from "../contexts/AppContext";
import { getData } from "../../lib/utils";

import Header from "../Headers/Header";
 
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import LinkMedia from "../PropertyList/LinkMedia";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SideNav = () => {

 
  const { galleryId, section } = useParams();
 
  const [selectedFolderIndex, setSelectedFolderIndex] = useState(null);
  const [selectedFolder,setSelectedFolder]=useState(false)
  

  const { value } = useContext(Context);
 
  const [appState, setAppState] = value; 
  const [fullData, setFullData] = useState(appState.allFolderData);
  
  const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  
  let Icon = Icons[capitalizeFirstLetter(section)+"C"];
 
  console.log(appState.activePanel, "Studio Side Nav111",capitalizeFirstLetter(section)+"C")

  useEffect(()=>{
    setAppState((prevState) => {
      return { ...prevState, 
        activePanel:capitalizeFirstLetter(section)+"C",
     
      
      };
    });
  
  },[])

  useEffect(()=>{
      const fetchData = async () => {
        try {
          const response = await getData("admin/admin-details");
          console.log("RESPONSE NOW", response.admin);
          setAppState((prevState) => {
            return { ...prevState, 
              adminDetails:response.admin,
           
            
            };
          });
        } catch (error) {
          console.error("Error fetching admin details:", error);
        }
      };
    
      fetchData();
    },[])

    const [modalOpen, setModalOpen] = useState(appState.modalData);
 
  const mainDiv = useRef();
useEffect(() => {
  
  setModalOpen(appState.modalData); // modalOpen को अपडेट करें
}, [appState.modalData]);
 
  useEffect(() => {
    const adjustHeight = () => {
      $("#mainDiv").css({ height: window.innerHeight - $("#header").height() + "px" });
    };
    setTimeout(adjustHeight, 1000);
    adjustHeight();
  }, [fullData]);


  

  const BASE_ITEMS = [
   
    {
      id: "accountsetting",
      name: "AccountSettingC",
      icon:"AccountSettingC",
      txt:"Account Setting"
    },
    {
      id: "companysetting",
      name: "CompanySettingC",
      icon:"CompanySettingC",
      txt:"Company Setting"
    },
    {
      id: "domainsetting",
      name: "DomainSettingC",
      icon:"DomainSettingC",
      txt:"Domain Setting"
    },
    
    {
      id: "planbill",
      name: "PlanBillC",
      icon:"PlanBillC",
      txt:"Plan & Billing"
    },
   
   
    {
      id: "creditusage",
      name: "CreditUsageC",
      icon:"Text",
      txt:"Credits Usage"
    },


   
      

  ];

  return (
    <div className="relative min-h-screen">
      <Header />
       
      <div className="md:flex min-h-screen pb-8 border-2" id="mainDiv" ref={mainDiv}>
      
        <Sidebar BASE_ITEMS={BASE_ITEMS} fullData={fullData} setAppState={setAppState} appState={appState} />
        <ContentArea Icon={Icon} />
      </div>
    </div>
  );
};






//Side Bar component
const Sidebar = ({ BASE_ITEMS, fullData, setAppState, appState }) => {

  const { galleryId, section } = useParams();
  return(

 
  <div
    className=" text-[0.9rem] font-semibold sidebar bg-[#eeeeee]   w-[280px] space-y-6 py-7 absolute inset-y-0 left-0 transform -translate-x-full md:relative md:translate-x-0 transition duration-200 ease-in-out"
  >
    <Link key={'link'} to="/studio/galleries">
    <button className="w-full relative overflow-hidden px-4 py-2 text-white bg-gray-800 rounded-md hover:bg-gray-700 active:scale-95 transition duration-300 ease-in-out shadow-md">
  Go Back
</button>
</Link>

<div className="flex items-center p-4 border-b text-black">
        <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-yellow-800 text-white rounded-full text-lg font-bold">
            <FontAwesomeIcon icon="fa-solid fa-user" />
        </div>
        <div className="ml-4">
          <div className="text-lg font-semibold text-gray-800">{appState?.adminDetails?.name}</div>
          <div className="text-sm text-gray-500">{appState?.adminDetails?.email}</div>
        </div>
       
      </div>
    <nav >
      {BASE_ITEMS.map((item,index) => (
         <Link key={'link'+index} to={`/studio/account/${item.id}`}>
        <PanelListItem key={'studio'+index} {...item} activePanel={appState.activePanel} />
        </Link>
      ))}
    </nav>
    
  </div>
);
}







//CONTENT AREA COMPONENT
const ContentArea = ({ Icon }) => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  //console.log("IIIIIIIIIIII ", Icon); // For debugging

  return (
  <div id="sideDetailedTray" className="flex relative w-full border-2 border-[#a5bce9] bg-white rounded-lg mt-2 mb-8 mx-2">
  
   
   
  { <Icon  appState={appState}/> }
   
  </div>
)};







//this new folder component
const PanelListItem = ({ name, icon, txt, activePanel }) => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;  
 
  
  const Icon = Icons[icon];
 
  return (
    <div
    id="EditorPanelList"
 
    onClick={() => {

var obj = {
  activePanel: name
}
 
console.log("CLICK ",name)
setAppState((prevState) => {
  return { ...prevState, 
    activePanel:name,
 
  
  };
});

    }}

    className={`px-4 w-full h-16 flex items-center justify-center text-xl font-normal select-none transition-all duration-500 gap-2 cursor-pointer 
      ${name === activePanel ? "bg-[#854d0e]" : "bg-gray-200"} 
      ${name === activePanel ? "hover:text-[#000000]" : "hover:bg-[#854d0e] "} 
      hover:transition-all hover:duration-1000`}

  >
        
    <div>{txt}</div>

  </div>
  );
};

export default SideNav;
